module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"maxLengthError":"Message is exceeding 50 symbols"},"et":{"maxLengthError":"Message is exceeding 50 symbols"},"ru":{"maxLengthError":"Message is exceeding 50 symbols"}}')
  delete Component.options._Ctor
}
